import { BsCalendar } from 'react-icons/bs';
import { CartAssignmentReplicate } from '../CartAssignmentReplicate';
import { CartCalendarItem } from './CartCalendarItem';
import { months } from '@monorepo/helpers';
import { typeCartAssignment, typeCartsDoc } from '@monorepo/models';
import { useState, FC, Dispatch, SetStateAction } from 'react';

type propsType = {
    cartsDoc: typeCartsDoc;
    deleteAssignment: (assignment: typeCartAssignment) => void;
    nextMonth: boolean;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
    thisMonth: boolean;
};

export const CartCalendar: FC<propsType> = ({ cartsDoc, deleteAssignment, nextMonth, setRefreshCounter, thisMonth }) => {
    const [month, setMonth] = useState<number>(new Date().getMonth());
    const [year, setYear] = useState<number>(new Date().getFullYear());

    return (
        <div className={'container mt-4'}>
            {(thisMonth || nextMonth) ?
                <h2 className={'btn-general-blue text-center py-3 mb-4'}>
                    {month && `${months[month]} ${year}`}
                </h2>
                :
                <div className={'text-center'}>
                    <div className={'text-center mb-4'}>
                        <div className={'my-3 cart-calendar-title'}>
                            <h1 className={'cart-calendar-heading'}>
                                <strong>Viendo:</strong> {months[month]?.toLocaleUpperCase()} {year} <BsCalendar className={'ms-1 mb-2'} />
                            </h1>
                        </div>
                        <div className={'d-flex justify-content-center px-2'}>
                            <input type={'month'}
                                id={'monthSelect'}
                                className={'form-control'}
                                value={`${year}-${(month + 1).toString().padStart(2, '0')}`}
                                onChange={e => {
                                    const data = e.target.value?.split('-');
                                    if (data.length > 1) {
                                        setYear(parseInt(data[0]));
                                        const m = parseInt(data[1]);
                                        setMonth(m - 1);
                                    } else {
                                        setMonth(new Date().getMonth());
                                        setYear(new Date().getFullYear());
                                    }
                                }}
                                style={{ maxWidth: '300px' }}
                            />
                        </div>
                    </div>
                </div>
            }
            {<CartAssignmentReplicate
                    cartsDoc={cartsDoc}
                    month={month}
                    setRefreshCounter={setRefreshCounter}
                    year={year}
                />
            }
            {cartsDoc.points?.filter(p => !p.wasDeleted).map(p =>
                <CartCalendarItem key={p.id}
                    cartsDoc={cartsDoc}
                    deleteAssignment={deleteAssignment}
                    point={p}
                    month={month}
                    setRefreshCounter={setRefreshCounter}
                    year={year}
                />
            )}
        </div>
    )
}
